import {Grid, makeStyles} from '@yandex-delivery/blocks'
import type {ContentSeparatorItem} from 'src/api/types'

type Props = {
  item: ContentSeparatorItem
}

const useClasses = makeStyles(
  theme => ({
    divider: {
      height: 1,
      backgroundColor: theme.go?.schemes?.colors?.system?.line || '#D2D0CC',
    },
  }),
  {name: 'Separator'},
)

export const Separator: React.FC<Props> = () => {
  const classes = useClasses()

  return <Grid className={classes.divider} />
}
